"use client";

import Fieldset from "@client/components/lead-form/components/fieldset";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import { Tile } from "@ui/js/components/tiles/tile";
import { Field, useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "payment-situation";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function PaymentSituation() {
	const { setFieldValue } = useFormikContext();
	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset
			dialog="Knowing how you handle payments helps us create a consolidation plan that fits your financial situation and goals, making it easier to get rid of your debts efficiently. If you're only paying the minimum or less than the minimum, it may mean you need a plan which lowers your monthly payment and your overall debt amount."
			legend="How have you been paying on your debt recently?"
		>
			<Field
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__payments_in_full`,
				)}
				label="Paying above the minimums"
				value="payments_in_full"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__pay_only_minimum`,
				)}
				label="Paying the minimums"
				value="pay_only_minimum"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__cant_pay_minimum`,
				)}
				label="Not keeping up with the minimums"
				value="cant_pay_minimum"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
